import React from 'react';
import Config from '../../config/Config';
import moment from 'moment';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { changeActiveCourse } from '../../redux/changeCourse/changeCourse.actions';
import Zoom from '../utils/animations/zoom';

const mapDispatchToProps = (dispatch) => {
	return {
		changeActiveCourse: (id) => dispatch(changeActiveCourse(id)),
	};
};

const CourseCard = ({
	isNewCourse,
	calendly_url,
	close_date,
	course_title,
	percentcomplete,
	course_id,
	changeActiveCourse,
}) => {
	let showProgress = calendly_url !== '' ? false : true;

	const initAssessment = (id) => {
		if (percentcomplete < 100) {
			changeActiveCourse(id)
		}
	}

	return (
		<Zoom className="dash-courses" onClick={() => initAssessment(course_id)}>
			<div className="dash-course-logo">
				<img
					src={Config.STORAGEPATH + 'img/courses/' + course_id + '.png'}
					alt="courseimage"
				/>
			</div>
			<div className="dash-course-decs">
				<p>{course_title}</p>
				<div className="dash-course-decs-bottom">
					<button aria-label="Start" className="btn btn-primary">
						{showProgress
							? percentcomplete === 100
								? 'Completed'
								: percentcomplete > 0
									? 'Continue'
									: 'Start'
							: 'View'}
					</button>
					<p className="dash-decs-date">
						<strong>Valid until</strong> -:-
						{moment(close_date).format('D MMM YYYY')}
					</p>
				</div>
			</div>
		</Zoom>
	);
};

export default compose(connect(null, mapDispatchToProps))(CourseCard);
